/* ============================================================
   Landing system — behaviour for every landing-*.liquid section.

   Three things, no dependencies:
     · tap-to-reveal on discussion prompts
     · reveal-on-scroll for section content
     · the sticky buy bar, which shows past the hero and stands down
       while the real purchase block is on screen

   Everything is initialised per element and guarded with a flag, so
   re-running after a Shopify theme-editor section reload is harmless.
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- tap to reveal ---------- */
  function initReveals(root) {
    (root || document).querySelectorAll('.landing-reveal').forEach(function (el) {
      if (el.dataset.landingReady === 'true') return;
      el.dataset.landingReady = 'true';
      el.setAttribute('aria-expanded', 'false');
      el.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        el.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initScrollReveal(root) {
    var items = (root || document).querySelectorAll('.landing__rv');
    if (!items.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -5% 0px' }
    );

    items.forEach(function (el) {
      if (el.dataset.landingReady === 'true') return;
      el.dataset.landingReady = 'true';
      io.observe(el);
    });
  }

  /* ---------- sticky buy bar ----------
     Note for anyone editing the theme: `overflow: hidden` on ANY ancestor
     turns that ancestor into a clipping container and silently stops
     position:sticky from pinning. If this bar stops appearing, look for a
     wrapper with overflow:hidden before looking at this file. */
  function initSticky(root) {
    var bar = (root || document).querySelector('.landing-sticky');
    if (!bar || bar.dataset.landingReady === 'true') return;
    bar.dataset.landingReady = 'true';

    var hero = document.querySelector('[data-landing-hero]');
    var buy = document.getElementById('landing-buy');
    var pastHero = !hero;
    var buyOnScreen = false;

    function sync() {
      bar.classList.toggle('is-on', pastHero && !buyOnScreen);
    }

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-on');
      return;
    }

    if (hero) {
      new IntersectionObserver(
        function (entries) {
          pastHero = !entries[0].isIntersecting;
          sync();
        },
        { threshold: 0 }
      ).observe(hero);
    }

    if (buy) {
      new IntersectionObserver(
        function (entries) {
          buyOnScreen = entries[0].isIntersecting;
          sync();
        },
        { threshold: 0 }
      ).observe(buy);
    }

    sync();
  }

  function init(root) {
    initReveals(root);
    initScrollReveal(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor re-renders a single section without a page load. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
